<template>
  <div id="map-container">
    <coordinates></coordinates>
    <div id="v-step-4" class="map-tools-container">
      <colorbar></colorbar>
      <layer-selections></layer-selections>
    </div>
    <!-- <div class="draw-info-container" v-if="showMeasurement">
      {{lineLength}}
    </div> -->
  </div>
</template>
<script>
// Eslint disabled for all variables not in camelcase
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable */
import _ from 'lodash';
import * as turf from '@turf/turf';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
// import MapboxDraw from '@mapbox/mapbox-gl-draw';
import Vue from 'vue';
import { mapState, mapMutations, mapActions } from 'vuex';

import {
  // OOISITEURL,
  // SPIDERFY_FROM_ZOOM,
  SITES_POLYGON_POLY_MINZOOM,
  SITES_POLYGON_POLY_MAXZOOM,
  SITES_POLYGON_LABELS_MAXZOOM,
  SITES_POLYGON_LABELS_MINZOOM,
  SITES_ICONS_MIN_ZOOM,
  INITIAL_LABELS_MIN_ZOOM,
  INITIAL_LABELS_MAX_ZOOM,
  INITIAL_SITE_MIN_ZOOM
} from '../../utils/constants';

import { centerPopup } from '../../utils/popup';
// import MapboxglSpiderifier from '../../utils/spider';
import MapboxGLButtonControl from './MapboxGLButtonControl';

import {
  InitialPolygons,
  InitialLabels,
  CityLabels,
  bathymetryLayers,
} from './staticGeom';
import InstrumentsPopupVue from './InstrumentsPopup';
import MultiFeaturesPopupVue from './popups/MultiFeaturesPopup';
import LayerSelectionsVue from './LayerSelections';
import ColorbarVue from './Colorbar';
import CoordinatesVue from './coordinates';

const TILESERVER = `${process.env.TILESERVER}`;
const COGEO_BUCKET = `${process.env.COGEO_BUCKET}`;

export default {
  data() {
    return {
      openPopup: null,
      flying: false,
      mapObject: null,
      map: null,
      store: this.$store,
      mediaURL: `${process.env.APIBASE}/media/media`,
      accessToken: process.env.MapboxToken,
      cursorLngLat: [0, 0],
      cursorElevation: 0,
      getElevation: null,
      bathymetryLayers,

      // Draw states
      draw: null,
      // showMeasurement: false,
      lineLength: '',

      // Open instruments popup
      instrumentsPopup: null,
      infraPopup: null,
      clickedFeatures: [],

      ooiURL: `${process.env.OOIURL}`,
      mooringCodes: ['ISSM', 'ISSP', 'SHSM', 'SHSP', 'OSSM', 'OSPM'],
    };
  },
  components: {
    'layer-selections': LayerSelectionsVue,
    colorbar: ColorbarVue,
    'coordinates': CoordinatesVue,
  },
  mounted() {
    const center = this.getCenter();
    const { homeBounds, bounds } = this.getMapBounds(center);

    this.initMap(center, bounds);

    const tooltip = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      anchor: 'left',
      offset: 10,
    });

    // const platformPopup = new mapboxgl.Popup({
    //   closeButton: true,
    //   closeOnClick: true,
    //   anchor: 'bottom',
    // });

    const sitesPopup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true,
      offset: 25,
    });
    this.map.on('click', () => {
      this.mapSelectInfrastructure({ infrastructure: null });
    });

    this.map.on('zoom', () => {
      // On map zoom reset any clicked infrastructures.
      // this.resetInfraSelections();

      /* Stashing this for now, closes instruments popup
      if (this.instrumentsPopup) {
        if (this.instrumentsPopup.isOpen()) {
          this.instrumentsPopup.remove();
          this.instrumentsPopup = null;
        }
      }
      */

      // Closes infrastructure list popup
      if (this.infraPopup) {
        if (this.infraPopup.isOpen()) {
          this.infraPopup.remove();
          this.infraPopup = null;
        }
      }
    });

    this.map.on('load', () => {
      this.setCustomConfig();
      this.addLatLngController();
      this.addNavControl();
      this.addHomeResetButton(homeBounds);
      this.map.boxZoom.enable();

      // Adds the initial Layers
      // this.loadIcons();
      // this.loadinfraIcons();
      this.addBathymetry();
      this.addMosaics();
      this.addCables(sitesPopup);
      this.addCities();
      this.addInstrumentCluster();
      this.addInfrastructures();
      this.addMoorings();
      this.setupInteractions();

      this.addSearchResults();
      this.addInstCheckboxes();
      this.addInfraCheckboxes();

      // Add Initial and Site area boxes
      this.addSiteAreas(tooltip, sitesPopup);
      this.addInitialAreas(tooltip, sitesPopup);

      // Get current map view for colorbar
      this.getCurrentMapView();

      // AddDrawControl
      //this.addDrawControl();
      // /* ------------------------------------- */

      // /* Event Handlers */
      // function legendModal() {
      //   if (document.getElementById('map-sidebar-icon').style.display === 'none') {
      //     document.getElementById('map-sidebar').style.display = 'none';
      //     document.getElementById('map-sidebar-icon').style.display = '';
      //   } else if (document.getElementById('map-sidebar-icon').style.display === '') {
      //     document.getElementById('map-sidebar').style.display = '';
      //     document.getElementById('map-sidebar-icon').style.display = 'none';
      //   }
      // }
      // /* Instantiate new controls with custom event handlers */
      // const legendPoint = new MapboxGLButtonControl({
      //   className: 'mapbox-gl-draw_legend',
      //   title: 'Icon Legend',
      //   eventHandler: legendModal,
      // });
      // map.addControl(legendPoint, "top-left");
    });
  },
  computed: {
    ...mapState({
      instrumentsCatalog: state => state.instrumentsCatalog,
      instruments: state => state.instruments,
      infrastructures: state => state.infrastructures,
      cables: state => state.cables,
      sites: state => state.sites,
      areas: state => state.areas,
      currentSite: state => state.currentSite,
      selectedInfraList: state => state.selectedInfraList,
      searchResults(state) {
        if (state.filteredCatalog.length > 0) {
          const instrumentsPoints = state.filteredCatalog.map(inst =>
            turf.point([inst.lon, inst.lat], { ...inst }),
          );
          return turf.featureCollection(instrumentsPoints);
        } else {
          return { type: 'FeatureCollection', features: [] }
        }
      },
      // The logic to find the instrument points based on the inst checkbox
      // selection (similar to how the instrument geojson is created with minor
      // tweaks)
      instCheckboxes(state) {
        const selectedValue = state.instCheckboxSelection;
        if (selectedValue.length > 0) {
          const instrumentsPoints = this.instruments.map((inst) => {
            if (selectedValue.includes(inst.instrument_name)) {
              const instObj = { ...inst, asset_type: `${inst.asset_type}` };
              return turf.point([inst.lon, inst.lat], instObj);
            }
            return null;
          });
          const rmUndefinedPoints = _.remove(instrumentsPoints, null);
          return turf.featureCollection(rmUndefinedPoints);
        } else {
          return { type: 'FeatureCollection', features: [] }
        }
      },
      // The logic to find the infra points based on the infra checkbox
      // selection (similar to how the infra geojson is created with minor
      // tweaks)
      infraCheckboxes(state) {
        const selectedInfraValue = state.infraCheckboxSelection;
        if (selectedInfraValue.length > 0) {
          const infraPoints = this.infrastructures.map((infra) => {
            if (selectedInfraValue.includes(infra.infraName)) {
              const featObj = { ...infra, site_rd: `${infra.reference_designator.split('-')[0]}` }
              return turf.point([infra.lon, infra.lat], featObj);
            }
            return null;
          });
          const rmUndefinedPoints = _.remove(infraPoints, null);
          return turf.featureCollection(rmUndefinedPoints);
        } else {
          return { type: 'FeatureCollection', features: [] }
        }
      },
    }),
    /* ---------------------------------------- */
    MapboxGLButton() {
      return Vue.extend(MapboxGLButtonControl);
    },
    /* ---------------------------------------- */
    infraGeoJson() {
      // Creates infrastructures geojson from infrastructures list 
      const infrastructurePoints = this.infrastructures.map((infra) => {
        const featObj = { ...infra, site_rd: `${infra.reference_designator.split('-')[0]}` }
        return turf.point([infra.lon, infra.lat], featObj)
      });
      return turf.featureCollection(infrastructurePoints);
    },
    /* ---------------------------------------- */
    mooringsGeoJson() {
      // Creates moorings geojson from infrastructures list (uncabled)
      // ISSM, ISSP, SHSM, SHSP, OSSM, OSPM
      const sitePoints = [];
      this.infrastructures.map(inst =>{
        const site_rd = inst.reference_designator.split('-')[0]
        if (this.mooringCodes.includes(site_rd.substring(4))){
          sitePoints.push(turf.point([inst.lon, inst.lat], { ...inst, site_rd }))
        }
      });
      return turf.featureCollection(_.uniqBy(sitePoints, 'properties.site_rd'));
    },
    /* ---------------------------------------- */
    instrumentsGeojson() {
      // Creates instruments geojson from instruments list
      const instrumentsPoints = this.instruments.map(inst =>
        turf.point([inst.lon, inst.lat], { ...inst, asset_type: `${inst.asset_type}` }),
      );
      return turf.featureCollection(instrumentsPoints);
    },
    /* ---------------------------------------- */
    bathymetryLayersGeoJson() {
      // Creates bathymetry layers feature collection
      // used to filter map view
      const collections = []
      this.bathymetryLayers.forEach((layer) => {
        if (!layer.name.includes("base-")) {
          const geoJson = turf.bboxPolygon(layer.bounds);
          collections.push({ ...geoJson, properties: { ...layer } });
        }
      })
      return turf.featureCollection(collections);
    },
    /* ---------------------------------------- */
    bathymetryInView: {
      // Setup a getter and setter
      // for a list of selected infrastructures
      get() {
        return this.$store.state.bathymetryInView;
      },
      set(value) {
        this.setBathymetryInView({ layers: value });
      },
    },
    /* ---------------------------------------- */
  },
  methods: {
    ...mapMutations(['setMap']),
    ...mapActions([
      'mapSelectInfrastructure',
      'mapSelectInst',
      'getInfraWPContent',
      'setInfraDetailsContent',
      'setSelectedInfra',
      'setSelectedInstrument',
      'setBathymetryInView',
      'toggleSidebar',
      'determineSidebarContent',
    ]),
    /* ---------------------------------------- */
    checkMapViewLap(currentBoundsPoly) {
      /*
        Function to figure out if current view overlaps with any
        bathymetry layers bounds.
      */
      const filteredFeatures = this.bathymetryLayersGeoJson.features.filter((feat) => {
        const layer = this.map.getLayer(feat.properties.name);
        if (layer.visibility == 'visible') {
          // Use only visible layers to figure out overlap
          const viewWithinLayer = turf.booleanWithin(
            currentBoundsPoly,
            feat,
          )
          if (viewWithinLayer) {
            return feat
          } else {
            // If not within view see if layer intersects
            const intersectionPoly = turf.intersect(
              currentBoundsPoly,
              feat,
            );
            if (intersectionPoly) {
              const intersectionArea = turf.area(intersectionPoly);
              if (intersectionArea > 90000000) {
                return feat;
              }
            }
          }
        }
      });
      if (filteredFeatures.length > 0) {
        this.bathymetryInView = filteredFeatures.map((feat) => {
          return { name: feat.properties.name, colorbar: feat.properties.colorbar }
        });
      } else {
        this.bathymetryInView = [];
      }
    },
    /* ---------------------------------------- */
    getCurrentMapView() {
      this.map.on('moveend', () => {
        const currentZoom = this.map.getZoom();
        if (currentZoom > SITES_ICONS_MIN_ZOOM) {
          const currentBounds = _.flattenDeep(this.map.getBounds().toArray());
          const currentBoundsPoly = turf.bboxPolygon(currentBounds);
          this.checkMapViewLap(currentBoundsPoly);
        }  
      });
    },
    /* ---------------------------------------- */
    openFeaturesPopup(e, features) {
      // Open infrastructure popup on map based on
      // which infrastructures has been selected.
      // *This will open up for multiple infrastrustures close to each other only*
      const InfraPopupClass = Vue.extend(MultiFeaturesPopupVue);

      // create a new Vue component with your props for this Popup
      const popupInstance = new InfraPopupClass({
        propsData: {
          features,
        },
        store: this.$store,
      });
      const popup = new mapboxgl.Popup({ anchor: 'bottom', maxWidth: '500px' })
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML('<div id="infra-popup-content" style="width: 500px;"></div>')
        .addTo(this.map);

      // mount this Vue component within the empty div Mapbox GL JS has just
      // created in the DOM
      popupInstance.$mount('#infra-popup-content');

      // since the size of the popup may have changed when mounting the Vue
      // component, force an update for dynamic positioning
      popup._update();

      centerPopup(this.map, popup, false);

      this.infraPopup = popup;
    },
    /* ---------------------------------------- */
    openInstrumentPopup(e, feature) {
      // Open instrument popup on map based on
      // which instruments has been selected.
      // *This will open up for multiple instruments close to each other only*
      const InstrumentsPopupClass = Vue.extend(InstrumentsPopupVue);

      // create a new Vue component with your props for this Popup
      const popupInstance = new InstrumentsPopupClass({
        propsData: {
          feature: feature.properties,
        },
        store: this.$store,
      });
      const popup = new mapboxgl.Popup({ anchor: 'bottom', maxWidth: '300px' })
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(
          '<div id="instruments-popup-content" style="width: 500px;"></div>',
        )
        .addTo(this.map);

      // mount this Vue component within the empty div Mapbox GL JS has just
      // created in the DOM
      popupInstance.$mount('#instruments-popup-content');

      // since the size of the popup may have changed when mounting the Vue
      // component, force an update for dynamic positioning
      popup._update();

      centerPopup(this.map, popup, false);

      this.instrumentsPopup = popup;
    },
    /* ---------------------------------------- */
    getCenter() {
      let center;
      // Figure out dataform current sites and set center appropriately
      // to the center of all research sites
      if (this.currentSite !== '') {
        // Get the coordinate of the selected site
        center = this.sites.features.filter((val) => {
          if (val.properties.site_rd === this.currentSite) {
            return val;
          }
          return null;
        })[0].geometry.coordinates;
      } else {
        center = turf.centroid(this.sites).geometry.coordinates; // center of point
      }
      return center;
    },
    /* ---------------------------------------- */
    getMapBounds(center) {
      // Creates a bounding box that will be used to limit zoom out functionality
      // so users can only see bathymetry layer
      const point = turf.point(center);

      const bufferedHome = turf.buffer(point, 175, { units: 'miles' });
      const bboxHome = turf.bbox(bufferedHome);

      const homeSW = bboxHome.splice(0, 2);
      const homeNE = bboxHome;

      const homeBounds = [homeSW, homeNE];

      // This sets SW and NE bounds of a box to limit zoom functionality of map, hardcoded for now
      const bounds = [-135.648838, 41.07155429619806, -120.94230622899997, 49.58103];
      return { homeBounds, bounds };
    },
    /* ---------------------------------------- */
    initMap(center, bounds) {
      mapboxgl.accessToken = this.accessToken;
      this.map = new mapboxgl.Map({
        container: 'map-container',
        style: 'mapbox://styles/ooica/ckrf8qx8x46s718o2hhkm6vwh',
        center,
        // sets the max bounds of box to above lat/long coordinates
        // based on the smallest base bathy.. in this case it's the blue
        maxBounds: bounds,
        maxZoom: 25,
        zoom: 6.7,
        attributionControl: false,
      });
      // Save map to store @ webmap
      this.setMap(this.map);
      this.addFullScreen();
      this.addAttribution();
      this.addScalebar();
    },
    /* ---------------------------------------- */
    // Add fullscreen button at top left corner of map above zoom and home buttons
    addFullScreen() {
      this.map.addControl(
        new mapboxgl.FullscreenControl({
          container: document.querySelector('#app-page'),
        }),
        'top-left',
      );
    },
    /* ---------------------------------------- */
    // Add attribution bar to bottom left of map below scale bar
    addAttribution() {
      this.map.addControl(
        new mapboxgl.AttributionControl({
          compact: false,
          customAttribution: [
            '<a href="https://www.washington.edu/">University of Washington</a>',
            '<a href="https://www.ocean.washington.edu/">School of Oceanography</a>',
          ],
        }),
      );
    },
    /* ---------------------------------------- */
    // Add scale bar (in km) to the bottom left of map
    addScalebar() {
      const scale = new mapboxgl.ScaleControl({
        maxWidth: 100,
        unit: 'imperial',
      });
      this.map.addControl(scale, 'bottom-right');
      scale.setUnit('metric');
    },
    /* ---------------------------------------- */
    setCustomConfig() {
      // Add catalog to map
      this.map.catalog = this.instrumentsCatalog;
      this.map.store = this.store;
      this.map.parent = this;
      this.map.doubleClickZoom.disable();
    },
    /* ---------------------------------------- */
    // Add all the different image mosaics onto the map
    addMosaics() {
      // Grotto Mosaic
      this.map.addLayer({
        id: 'grotto',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_4m_EG_GCS.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14696071994999,
            44.569889362850006,
            -125.14649114734999,
            44.570112154650005,
          ],
        },
      });
      // ASHES Mosaic
      this.map.addLayer({
        id: 'ashes_mosaic',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/ashes_mosaic_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -130.0141729267314,
            45.93307339599995,
            -130.01271635226854,
            45.933924443,
          ],
        },
      });
      // R1463_6m_Z Mosaic
      this.map.addLayer({
        id: 'R1463_6m_Z',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_6m_Z_gcs_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14602857125,
            44.570399835349995,
            -125.14561959905,
            44.57066015625,
          ],
        },
      });
      // R1463_6m_F Mosaic
      this.map.addLayer({
        id: 'R1463_6m_F',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_6m_F_gcs_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14742878884998,
            44.569372877250004,
            -125.14701221744998,
            44.56960251155,
          ],
        },
      });
      // R1463_6m_HRF24 Mosaic
      this.map.addLayer({
        id: 'R1463_6m_HRF24',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_6m_HRF24_gcs_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14772650574999,
            44.56971464085001,
            -125.14727438555,
            44.569959570150004,
          ],
        },
      });
      // R1463_6m_RSNC Mosaic
      this.map.addLayer({
        id: 'R1463_6m_RSNC',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_6m_RSNC_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14725883735,
            44.569410465249995,
            -125.14662527014998,
            44.56979377405,
          ],
        },
      });
      // R1463_6m_RSNE Mosaic
      this.map.addLayer({
        id: 'R1463_6m_RSNE',
        type: 'raster',
        layout: {
          visibility: 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}/mosaics/R1463_6m_RSNE_cog.tif`,
          ],
          tileSize: 256,
          minzoom: 19,
          maxzoom: 25,
          bounds: [
            -125.14731288735,
            44.57015365215,
            -125.14673782755,
            44.57060160245,
          ],
        },
      });
    },
    /* ---------------------------------------- */
    // Adds each layer of bathymetry
    // (base, hydrate endeavor, axial slope base, axial caldera, WA offshore, )
    addBathymetryLayer(layer, bounds){
      const layerObj = {
        id: layer.name,
        type: 'raster',
        layout: {
          visibility: layer.name.startsWith("blue-") ? 'none' : 'visible',
        },
        source: {
          type: 'raster',
          tiles: [
            `${TILESERVER}/cog/tiles/{z}/{x}/{y}.png?url=${COGEO_BUCKET}${layer.url}`,
          ],
          tileSize: 256,
          bounds,
        },
      }
      this.map.addLayer(layerObj);
    },
    addBathymetry() {
      this.bathymetryLayers.forEach((layer) => {
        this.addBathymetryLayer(layer, layer.bounds);
        // 4/20/2021 (Don. S.) Dynamic fetching of bounds needs to be further worked out
        // 
        // axios
        //   .get(`${TILESERVER}/cog/bounds?url=${COGEO_BUCKET}${layer.url}`)
        //   .then((response) => {
        //     this.addBathymetryLayer(layer, response.data.bounds);
        //   })
        //   .catch((error) => {
        //     this.addBathymetryLayer(layer, layer.bounds);
        //   });
      });
    },
    /* ---------------------------------------- */
    fetchClusterFeatures(feat, resolve) {
      const clusterSource = this.map.getSource(feat.source);
      const clusterId = feat.properties.cluster_id;
      const pointCount = feat.properties.point_count;
      clusterSource.getClusterLeaves(
        clusterId,
        pointCount,
        0,
        (error, childFeatures) => {
          resolve(
            childFeatures.map(cf => ({
              ...cf,
              properties: {
                ...cf.properties,
                source: feat.source,
              },
            })),
          );
        },
      );
    },
    /* ---------------------------------------- */
    async mapFeatures(e, features) {
      this.clickedFeatures = [];
      const allFeatures = [];
      let newFeat;
      features.forEach((feat) => {
        if (_.has(feat, 'properties.point_count')) {
          newFeat = new Promise((resolve) => {
            this.fetchClusterFeatures(feat, resolve);
          });
        } else {
          newFeat = Promise.resolve({
            ...feat,
            properties: {
              ...feat.properties,
              source: feat.source,
            },
          });
        }
        allFeatures.push(newFeat);
      });

      await Promise.all(allFeatures).then((values) => {
        this.clickedFeatures = _.flatten(values);
        if (this.clickedFeatures.length > 1) {
          this.openFeaturesPopup(e, this.clickedFeatures);
        } else if (this.clickedFeatures.length === 1) {
          // Open infrastructure detail right away for only 1
          const selectedFeature = this.clickedFeatures[0];
          if (
            selectedFeature.properties.source === 'infrastructures' ||
            selectedFeature.properties.source === 'infra-checkboxes') {
            this.resetInfraSelections();
            this.mapSelectInfrastructure({ infrastructure: selectedFeature });
            // Get infrastructure wordpress contents for selected infrastructures
            this.getInfraWPContent();
            // this.openSingleInfraPopup(e, selectedFeature);
            this.determineSidebarContent({ sidebarContent: 'infra-details' });
            this.toggleSidebar({ showSidebar: true });
          } else if (
            selectedFeature.properties.source === 'instrumentsSource' ||
            selectedFeature.properties.source === 'inst-checkboxes'
          ) {
            this.resetInstSelections();
            this.mapSelectInst({ instrument: selectedFeature });
            this.openInstrumentPopup(e, selectedFeature);
          } 
        }
      });
    },
    /* ---------------------------------------- */
    setupInteractions() {
      this.map.on('click', (e) => {
        // set bbox as 5px reactangle area around clicked point
        const bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        const features = this.map.queryRenderedFeatures(bbox, {
          layers: [
            'instrument-layers-clusters',
            'infra-icon',
            'instrument-layers-point',
            'instrument-checkbox-icons',
            'infra-checkbox-icons',
          ],
        });
        this.mapFeatures(e, features);
      });
    },
    /* ---------------------------------------- */
    // The 'INST' icons on the map
    addInstrumentCluster() {
      this.map.addSource('instrumentsSource', {
        type: 'geojson',
        data: this.instrumentsGeojson,
        cluster: true,
        maxzoom: 30,
        clusterProperties: { cluster_label: ['string', 'INST'] },
        clusterRadius: 15, // Radius of each cluster when clustering points (defaults to 50)
      });

      // CLUSTER SETUP
      this.map.addLayer({
        id: 'instrument-layers-clusters',
        type: 'circle',
        source: 'instrumentsSource',
        minzoom: SITES_ICONS_MIN_ZOOM,
        filter: ['has', 'point_count'],
        layout: {
          visibility: 'visible',
        },
        paint: {
          'circle-stroke-color': '#000000',
          'circle-stroke-width': 2,
          'circle-radius': 12,
          'circle-color': 'rgba(255, 255, 255, 1)',
        },
      });

      this.map.addLayer({
        id: 'cluster-text',
        type: 'symbol',
        source: 'instrumentsSource',
        filter: ['has', 'point_count'],
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'text-field': '{cluster_label}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 8,
          'text-allow-overlap': true,
          visibility: 'visible',
        },
        paint: {
          'text-color': '#000000',
        },
      });

      this.map.on('mouseenter', 'instrument-layers-clusters', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'instrument-layers-clusters', () => {
        this.map.getCanvas().style.cursor = '';
      });
      /* ---------------------------------------- */

      // UNCLUSTERED SETUP
      this.map.addLayer({
        id: 'instrument-layers-point',
        type: 'symbol',
        source: 'instrumentsSource',
        filter: ['!', ['has', 'point_count']],
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': false,
          'icon-image': ['get', 'asset_type'],
          'icon-size': 1,
          visibility: 'visible',
        },
      });

      this.map.on('mouseenter', 'instrument-layers-point', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'instrument-layers-point', () => {
        this.map.getCanvas().style.cursor = '';
      });
      /* ---------------------------------------- */

      // When a click event occurs on a feature in
      // the unclustered-point layer, open a popup at
      // the location of the feature, with
      // description HTML from its properties.
      // this.map.on('click', 'unclustered-point', (e) => {
      //   const coordinates = e.features[0].geometry.coordinates.slice();
      //   const prop = e.features[0].properties;
      //   // let tsunami;

      //   // if (e.features[0].properties.tsunami === 1) {
      //   //   tsunami = 'yes';
      //   // } else {
      //   //   tsunami = 'no';
      //   // }

      //   // Ensure that if the map is zoomed out such that
      //   // multiple copies of the feature are visible, the
      //   // popup appears over the copy being pointed to.
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   }

      //   new mapboxgl.Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(`magnitude: ${prop}`)
      //     .addTo(this.map);
      // });
    },
    /* ---------------------------------------- */
    addInstCheckboxes() {
      /* Add selected instrument icons to the map based on 
        checkbox selection on the sidebar
      */
      this.map.addSource('inst-checkboxes', {
        type: 'geojson',
        data: this.instCheckboxes,
      });
      this.map.addLayer({
        id: 'inst-checkboxes-highlight',
        type: 'circle',
        source: 'inst-checkboxes',
        paint: {
          'circle-radius': 18,
          'circle-color': 'rgb(0,255,255)',
          'circle-stroke-color': 'rgb(64,255,44)',
          'circle-stroke-width': 3,
          'circle-opacity': 0.0,
          'circle-blur': 0.2,
        },
      });

      // Instrument icon
      this.map.addLayer({
        id: 'instrument-checkbox-icons',
        type: 'symbol',
        source: 'inst-checkboxes',
        filter: ['!', ['has', 'point_count']],
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': false,
          'icon-image': ['get', 'asset_type'],
          'icon-size': 1,
          visibility: 'visible',
        },
      });

      this.map.on('mouseenter', 'instrument-checkbox-icons', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'instrument-checkbox-icons', () => {
        this.map.getCanvas().style.cursor = '';
      });
    },
    /* ---------------------------------------- */
    addInfraCheckboxes() {
      /* Add selected infrastructure icons to the map based on 
        checkbox selection on the sidebar
      */
      this.map.addSource('infra-checkboxes', {
        type: 'geojson',
        data: this.infraCheckboxes,
      });
      this.map.addLayer({
        id: 'infra-checkbox-highlight',
        type: 'circle',
        source: 'infra-checkboxes',
        paint: {
          'circle-radius': 18,
          'circle-color': 'rgb(0,255,255)',
          'circle-stroke-color': 'rgb(64,255,44)',
          'circle-stroke-width': 3,
          'circle-opacity': 0.0,
          'circle-blur': 0.2,
        },
      });
    
      // Infra icon
      this.map.addLayer({
        id: 'infra-checkbox-icons',
        type: 'symbol',
        source: 'infra-checkboxes',
        filter: ['!', ['has', 'point_count']],
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': false,
          'icon-image': ['get', 'asset_type'],
          'icon-size': 1,
          visibility: 'visible',
        },
      });

      this.map.on('mouseenter', 'infra-checkbox-icons', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'infra-checkbox-icons', () => {
        this.map.getCanvas().style.cursor = '';
      });
    },
    /* ---------------------------------------- */
    // The 'MOOR' icons on the map
    addMoorings() {
      this.map.addSource('moorings', {
        type: 'geojson',
        data: this.mooringsGeoJson,
      });
      // Circle icon
      this.map.addLayer({
        id: 'mooring-circle',
        type: 'circle',
        source: 'moorings',
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          visibility: 'visible',
        },
        paint: {
          'circle-stroke-color': '#000000',
          'circle-stroke-width': 2,
          'circle-radius': 15,
          'circle-color': 'rgba(255, 255, 255, 1)',
        },
      });
      // Text of icon
      this.map.addLayer({
        id: 'mooring-text',
        type: 'symbol',
        source: 'moorings',
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'text-field': 'MOOR',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 8,
          'text-allow-overlap': true,
          visibility: 'visible',
        },
        paint: {
          'text-color': '#000000',
        },
      });
    },
    /* ---------------------------------------- */
    addInfrastructures() {
      // Add infrastructures to map
      this.map.addSource('infrastructures', {
        type: 'geojson',
        data: this.infraGeoJson,
      });
      this.map.addLayer({
        id: 'infra-icon',
        type: 'symbol',
        source: 'infrastructures',
        minzoom: SITES_ICONS_MIN_ZOOM,
        layout: {
          'icon-allow-overlap': true,
          'icon-ignore-placement': false,
          'icon-image': ['get', 'asset_type'],
          'icon-size': 1,
          visibility: 'visible',
        },
      });
      // this.map.on('click', 'infra-icon', (e) => {
      //   const bbox = [
      //     [e.point.x - 5, e.point.y - 5],
      //     [e.point.x + 5, e.point.y + 5],
      //   ];
      //   const features = this.map.queryRenderedFeatures(bbox, {
      //     layers: ['infra-icon'],
      //   });

      //   if (features.length > 1) {
      //     // Open infrastructure popup when there are more than 1
      //     this.openInfraPopup(e, features);
      //   } else if (features.length === 1) {
      //     // Open infrastructure detail right away for only 1
      //     const selectedFeature = features[0];
      //     this.resetInfraSelections();
      //     this.mapSelectInfrastructure({ infrastructure: selectedFeature });
      //     // Get infrastructure wordpress contents for selected infrastructures
      //     this.getInfraWPContent();
      //   }
      // });

      this.map.on('mouseenter', 'infra-icon', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'infra-icon', () => {
        this.map.getCanvas().style.cursor = '';
      });

      // if (this.selectedInfraList.length === 0) {
      //   // Set initial list of selected infrastructure in store
      //   const infraList = this.infraGeoJson.features.map(
      //     feat => feat.properties.infraName,
      //   );
      //   this.setSelectedInfra({ selected: _.uniq(infraList) });
      // }

      // Set initial filter for infrastructure
      // based on the list of selected infrastructure in store
      // this.map.setFilter('infra-icon', [
      //   'match',
      //   ['get', 'infraName'],
      //   this.selectedInfraList,
      //   true,
      //   false,
      // ]);
    },
    resetInfraSelections() {
      // Resets infrastructure selections, closes infrastructure detail
      this.mapSelectInfrastructure({ infrastructure: null });
      this.setInfraDetailsContent({ wpContent: null });
    },
    resetInstSelections() {
      // Resets instrument selections, closes instrument detail
      this.mapSelectInst({ instrument: null });
    },
    /* ---------------------------------------- */
    addCables(sitesPopup) {
      /* Add cables to map */
      this.map.addSource('cables', {
        type: 'geojson',
        data: this.cables,
      });

      this.map.addLayer({
        id: 'cables-lines',
        type: 'line',
        source: 'cables',
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#FFFFFF',
          'line-width': 2.0,
        },
      });

      const name = this.cables.properties.name ? this.cables.properties.name : 'Backbone Cable';
      const URL = this.cables.properties.wp_url ? this.cables.properties.wp_url : 'https://interactiveoceans.washington.edu/technology/cables-connectors/';
      const content = this.cables.properties.description ? this.cables.properties.description : 'Approximately 900 km of primary backbone electro-optical cable have been installed from the Shore Station to the seven Primary Node locations spanning the Juan de Fuca Plate. The cable provides power (10 kV DC, up to 8 A) and communications (10 Gb/s) via fiber-optics and copper between the Primary Nodes and the Shore Station in Pacific City, Oregon.';
      const image = this.cables.properties.image_url ? this.cables.properties.image_url : 'https://s3.us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/01/03192635/cableacrosscollapse3-300x169.jpg';

      const sitePopupContent = `<h5>${name}</h5>
              <div><img src="${image}" width="200"/></div>
              <div>${content}</div>
              <p><a href="${URL}" target="_blank">Read More <i class="fas fa-external-link-alt"></i></a></p>`;

      this.map.on('mouseenter', 'cables-lines', (e) => {
        if (this.map.getZoom() < INITIAL_SITE_MIN_ZOOM) {
          this.map.getCanvas().style.cursor = 'pointer';
          sitesPopup
            .setLngLat(e.lngLat)
            .setHTML(sitePopupContent)
            .addTo(this.map);
        }
      });
    },
    /* ---------------------------------------- */
    addCities() {
      /*
      Add City Labels - these are hardcoded using information
      from the staticGeom.js under const CityLabels
      */
      this.map.addSource('city-labels', {
        type: 'geojson',
        data: CityLabels,
      });

      this.map.addLayer({
        id: 'city-circle',
        type: 'circle',
        source: 'city-labels',
        paint: {
          // make circles larger as the user zooms from z12 to z22
          'circle-radius': {
            base: 1.75,
            stops: [
              [2, 3],
              [22, 180],
            ],
          },
          'circle-color': '#323232',
          'circle-stroke-color': '#ededed',
          'circle-stroke-width': 2,
        },
      });

      this.map.addLayer({
        id: 'city',
        type: 'symbol',
        source: 'city-labels',
        layout: {
          'text-field': '{city_name}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
          'text-allow-overlap': true,
          'text-offset': [0, 0.7],
          'text-anchor': 'top',
        },
        paint: {
          'text-color': '#ededed',
          'text-halo-width': 1.0,
          'text-halo-color': '#323232',
        },
      });
    },
    /* ---------------------------------------- */
    addSearchResults() {
      /* Add SearchResults w/ Search Results endpoint */
      this.map.addSource('search-results', {
        type: 'geojson',
        data: this.searchResults,
      });

      this.map.addLayer({
        id: 'search-results-highlight',
        type: 'circle',
        source: 'search-results',
        paint: {
          'circle-radius': 20,
          'circle-color': 'rgb(255,255,255)',
          'circle-stroke-color': 'rgb(57, 149, 163)',
          'circle-stroke-width': 2,
          'circle-opacity': 0.0,
          'circle-blur': 0.2,
        },
      });
    },
    /* ---------------------------------------- */
    // Add site information on the map
    addSiteAreas(tooltip, sitesPopup) {
      /* Add Sites Polygon w/ Areas Endpoint */
      this.map.addSource('site-areas', {
        type: 'geojson',
        data: this.areas,
      });

      this.map.addLayer({
        id: 'sites-polygon',
        type: 'fill',
        source: 'site-areas',
        minzoom: SITES_POLYGON_POLY_MINZOOM,
        maxzoom: SITES_POLYGON_POLY_MAXZOOM,
        layout: {},
        paint: {
          'fill-color': 'rgba(59, 57, 59, 0.55)',
          'fill-outline-color': '#FFFFFF',
        },
      });

      this.map.on('click', 'sites-polygon', (e) => {
        const coordinates = turf.centroid(e.features[0].geometry).geometry
          .coordinates;
        const wp_page = e.features[0].properties.wp_page;
        if (wp_page === '') {
          const name = e.features[0].properties.area_name;
          const content =
            'The Endurance Array is a multi-scaled array utilizing fixed and mobile assets to observe cross-shelf and along-shelf variability in the coastal upwelling region of the Oregon and Washington coasts. The array also provides an extensive spatial footprint that encompasses a prototypical eastern boundary current regime and connectivity with the Cabled Array.';
          const URL = e.features[0].properties.area_url;
          const sitePopupContent = `<h5>${name}</h5>
              <div>${content}</div>
              <p><a href="${URL}" target="_blank">Read More <i class="fas fa-external-link-alt"></i></a></p>`;

          sitesPopup
            .setLngLat(coordinates)
            // Builds the pop up card information based of each site
            .setHTML(sitePopupContent)
            .addTo(this.map);
        } else {
          let post = null;
          axios
            .get(`${process.env.OOIURL}/wp-json/wp/v2/pages/${wp_page}`)
            .then((response) => {
              post = response.data;
              const sitePopupContent = `<h5>${post.title.rendered}</h5>
              <div>${post.excerpt.rendered}</div>
              <p><a href="${post.link}" target="_blank">Read More <i class="fas fa-external-link-alt"></i></a></p>`;

              sitesPopup
                .setLngLat(coordinates)
                // Builds the pop up card information based of each site
                .setHTML(sitePopupContent)
                .addTo(this.map);
            });
        }
      });

      this.map.on('dblclick', 'sites-polygon', (e) => {
        const coordinates = turf.centroid(e.features[0].geometry).geometry
          .coordinates;
        this.map.flyTo({ center: coordinates, zoom: 11.25 });
      });

      // Change the cursor to a pointer when the mouse is over the places layer.
      this.map.on('mouseenter', 'sites-polygon', (e) => {
        this.map.getCanvas().style.cursor = 'pointer';
        if (this.map.getZoom() < SITES_POLYGON_LABELS_MINZOOM) {
          const site_name = e.features[0].properties.site_name;
          const coordinates = turf.centroid(e.features[0].geometry).geometry
            .coordinates;

          tooltip
            .setLngLat(coordinates)

            // Builds the pop up card information based of each site
            .setHTML(`<strong>${site_name}</strong>`)
            .addTo(this.map);
        }
      });

      // Change it back to a pointer when it leaves.
      // eslint-disable-next-line no-unused-vars
      this.map.on('mouseleave', 'sites-polygon', (e) => {
        this.map.getCanvas().style.cursor = '';
        if (tooltip !== undefined) {
          tooltip.remove();
        }
      });

      // Change it back to a pointer when it leaves.
      // eslint-disable-next-line no-unused-vars
      this.map.on('zoom', 'sites-polygon', (e) => {
        sitesPopup.remove();
      });

      // Zoomed in site areas for each Reserach Area, makes polygon labels
      const area_centers = this.getPolygonsCenters(this.areas);
      this.map.addSource('sites-polygon-labels', {
        type: 'geojson',
        data: area_centers,
      });
      this.map.addLayer({
        id: 'sites-polygons-labels',
        type: 'symbol',
        source: 'sites-polygon-labels',
        minzoom: SITES_POLYGON_LABELS_MINZOOM,
        maxzoom: SITES_POLYGON_LABELS_MAXZOOM,
        layout: {
          'text-field': '{area_name}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
          'text-allow-overlap': true,
          'text-anchor': 'top',
        },
        paint: {
          'text-color': '#ededed',
          'text-halo-width': 1.0,
          'text-halo-color': '#323232',
        },
      });
    },
    /* ---------------------------------------- */
    // Initial area information to the map (fully zoomed out)
    addInitialAreas(tooltip, sitesPopup) {
      /* Add Initial Polygon w/ staticGeom.js */
      this.map.addSource('initial-poly', {
        type: 'geojson',
        data: InitialPolygons,
      });
      this.map.addSource('initial-sites', {
        type: 'geojson',
        data: InitialLabels,
      });

      InitialPolygons.features.forEach((feature) => {
        const siteKey = feature.properties.site_key;
        const layerID = `inital-poly-${siteKey}`;
        if (!this.map.getLayer(layerID)) {
          this.map.addLayer({
            id: layerID,
            type: 'fill',
            source: 'initial-poly',
            minzoom: INITIAL_LABELS_MIN_ZOOM,
            maxzoom: INITIAL_LABELS_MAX_ZOOM,
            layout: {},
            paint: {
              'fill-color': 'rgba(59, 57, 59, 0.55)',
              'fill-outline-color': '#ededed',
            },
            filter: ['==', 'site_key', siteKey],
          });

          this.map.on('click', layerID, (e) => {
            const coordinates = turf.centroid(e.features[0].geometry).geometry
              .coordinates;
            const wp_page = e.features[0].properties.wp_page;

            let post = null;
            axios
              .get(`${process.env.OOIURL}/wp-json/wp/v2/pages/${wp_page}`)
              .then((response) => {
                post = response.data;
                const initialPopupContent = `<h5>${post.title.rendered}</h5>
                <div>${post.excerpt.rendered}</div>
                <p><a href="${post.link}" target="_blank">Read More <i class="fas fa-external-link-alt"></i></a></p>`;

                sitesPopup
                  .setLngLat(coordinates)
                  // Builds the pop up card information based of each site
                  .setHTML(initialPopupContent)
                  .addTo(this.map);
              });
          });

          this.map.on('dblclick', layerID, (e) => {
            const coordinates = turf.centroid(e.features[0].geometry).geometry
              .coordinates;
            this.map.flyTo({ center: coordinates, zoom: 10 });
          });

          // Change the cursor to a pointer when the mouse is over the places layer.
          this.map.on('mouseenter', layerID, (e) => {
            this.map.getCanvas().style.cursor = 'pointer';
            if (this.map.getZoom() < SITES_POLYGON_LABELS_MINZOOM) {
              const site_name = e.features[0].properties.site_name;
              const coordinates = turf.centroid(e.features[0].geometry).geometry
                .coordinates;

              tooltip
                .setLngLat(coordinates)

                // Builds the pop up card information based of each site
                .setHTML(`<strong>${site_name}</strong>`)
                .addTo(this.map);
            }
          });

          // Change it back to a pointer when it leaves.
          // eslint-disable-next-line no-unused-vars
          this.map.on('mouseleave', layerID, (e) => {
            this.map.getCanvas().style.cursor = '';
            if (tooltip !== undefined) {
              tooltip.remove();
            }
          });

          // Change it back to a pointer when it leaves.
          // eslint-disable-next-line no-unused-vars
          this.map.on('zoom', layerID, (e) => {
            sitesPopup.remove();
          });
        }
      });
      // Inital site boxes when fully zoomed out on the map
      this.map.addLayer({
        id: 'initial-poly-label2',
        type: 'symbol',
        source: 'initial-sites',
        minzoom: INITIAL_LABELS_MIN_ZOOM,
        maxzoom: INITIAL_LABELS_MAX_ZOOM,

        layout: {
          'text-field': '{site_name}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 11.5,
          'text-allow-overlap': true,
          'text-letter-spacing': 0.1,
        },
        paint: {
          'text-color': '#ededed',
          'text-halo-width': 1.0,
          'text-halo-color': '#323232',
        },
      });
    },
    /* ---------------------------------------- */
    fetchElevation() {
      axios.get('https://gis.ngdc.noaa.gov/arcgis/rest/services/DEM_mosaics/DEM_global_mosaic/ImageServer/identify', {
        params: {
          geometry: this.cursorLngLat.join(','),
          geometryType: 'esriGeometryPoint',
          returnGeometry: false,
          returnCatalogItems: false,
          f: 'json',
        },
      }).then((response) => {
        this.cursorElevation = parseFloat(response.data.value).toFixed(2);
        document.getElementById('elevation').innerHTML = `${this.cursorElevation} m`;
      }).catch(() => {
        document.getElementById('elevation').innerHTML = 'No data';
      });
    },
    stopFetchElevation() {
      if (this.getElevation) {
        clearTimeout(this.getElevation);
      }
    },
    /* ---------------------------------------- */
    addLatLngController() {
      /* This section is for the lat/long mouse tracking component on the top of
       * the map page
       */
      this.map.on('mousemove', (e) => {
        this.stopFetchElevation();
        const lat = e.lngLat.lat;
        const lng = e.lngLat.lng;
        document.getElementById('lat').innerHTML = lat.toFixed(5);
        document.getElementById('lng').innerHTML = lng.toFixed(5);
        this.cursorLngLat = [lng, lat];
        this.getElevation = setTimeout(() => {
          document.getElementById('elevation').innerHTML = 'Fetching ...';
          this.fetchElevation();
        }, 1000);
      });
    },
    /* ---------------------------------------- */
    addHomeResetButton(homeBounds) {
      const homePoint = new this.MapboxGLButton({
        propsData: {
          className: 'mapbox-gl-draw_home',
          title: 'Home zoom level',
          eventHandler: () => {
            this.map.fitBounds(homeBounds, {
              maxzoom: 10,
            });
          },
        },
      });

      this.map.addControl(homePoint, 'top-left');
    },
    /* ---------------------------------------- */
    addNavControl() {
      this.map.addControl(new mapboxgl.NavigationControl(), 'top-left');
    },
    /* ---------------------------------------- */
    /*
    addDrawControl() {
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          line_string: true,
          trash: true,
        },
        styles: [
          // ACTIVE (being drawn)
          // line stroke
          {
            id: 'gl-draw-line',
            type: 'line',
            filter: [
              'all',
              ['==', '$type', 'LineString'],
              ['!=', 'mode', 'static'],
            ],
            layout: {
              'line-cap': 'round',
              'line-join': 'round',
            },
            paint: {
              'line-color': '#D20C0C',
              'line-dasharray': [0.2, 2],
              'line-width': 2,
            },
          },
          // polygon fill
          {
            id: 'gl-draw-polygon-fill',
            type: 'fill',
            filter: [
              'all',
              ['==', '$type', 'Polygon'],
              ['!=', 'mode', 'static'],
            ],
            paint: {
              'fill-color': '#D20C0C',
              'fill-outline-color': '#D20C0C',
              'fill-opacity': 0.1,
            },
          },
          // polygon outline stroke
          // This doesn't style the first edge of the polygon,
          // which uses the line stroke styling instead
          {
            id: 'gl-draw-polygon-stroke-active',
            type: 'line',
            filter: [
              'all',
              ['==', '$type', 'Polygon'],
              ['!=', 'mode', 'static'],
            ],
            layout: {
              'line-cap': 'round',
              'line-join': 'round',
            },
            paint: {
              'line-color': '#D20C0C',
              'line-dasharray': [0.2, 2],
              'line-width': 2,
            },
          },
          // vertex point halos
          {
            id: 'gl-draw-polygon-and-line-vertex-halo-active',
            type: 'circle',
            filter: [
              'all',
              ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static'],
            ],
            paint: {
              'circle-radius': 5,
              'circle-color': '#FFF',
            },
          },
          // vertex points
          {
            id: 'gl-draw-polygon-and-line-vertex-active',
            type: 'circle',
            filter: [
              'all',
              ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static'],
            ],
            paint: {
              'circle-radius': 3,
              'circle-color': '#D20C0C',
            },
          },

          // INACTIVE (static, already drawn)
          // line stroke
          {
            id: 'gl-draw-line-static',
            type: 'line',
            filter: [
              'all',
              ['==', '$type', 'LineString'],
              ['==', 'mode', 'static'],
            ],
            layout: {
              'line-cap': 'round',
              'line-join': 'round',
            },
            paint: {
              'line-color': '#000',
              'line-width': 3,
            },
          },
          // polygon fill
          {
            id: 'gl-draw-polygon-fill-static',
            type: 'fill',
            filter: [
              'all',
              ['==', '$type', 'Polygon'],
              ['==', 'mode', 'static'],
            ],
            paint: {
              'fill-color': '#000',
              'fill-outline-color': '#000',
              'fill-opacity': 0.1,
            },
          },
          // polygon outline
          {
            id: 'gl-draw-polygon-stroke-static',
            type: 'line',
            filter: [
              'all',
              ['==', '$type', 'Polygon'],
              ['==', 'mode', 'static'],
            ],
            layout: {
              'line-cap': 'round',
              'line-join': 'round',
            },
            paint: {
              'line-color': '#000',
              'line-width': 3,
            },
          },
        ],
      });

      this.map.addControl(this.draw, 'top-left');

      this.map.on('draw.create', this.updateDrawInfo);
      this.map.on('draw.update', this.updateDrawInfo);
      this.map.on('draw.delete', this.updateDrawInfo);
    },
    updateDrawInfo() {
      const data = this.draw.getAll();
      if (data.features.length > 0) {
        const length = turf.length(data, { units: 'kilometers' });
        const length_meters = length * 1000;
        if (length_meters >= 1000) {
          this.lineLength = `${length.toFixed(2)} kilometers`;
        } else {
          this.lineLength = `${length_meters.toFixed(4)} meters`;
        }
        this.showMeasurement = true;
      } else {
        this.showMeasurement = false;
      }
    },*/
    /* ---------------------------------------- */
    getPolygonsCenters(polygons) {
      return turf.featureCollection(
        polygons.features.map((feature) => {
          const center = turf.centroid(feature);
          center.properties = { ...feature.properties };
          return center;
        }),
      );
    },
    /* ---------------------------------------- */
  },
  watch: {
    searchResults(newVal) {
      this.map.getSource('search-results').setData(newVal);
    },
    instCheckboxes(newVal) {
      this.map.getSource('inst-checkboxes').setData(newVal);
    },
    infraCheckboxes(newVal) {
      this.map.getSource('infra-checkboxes').setData(newVal);
    },
    /* ---------------------------------------- */
  },
};
</script>

<style>
.mapboxgl-ctrl-attrib-button {
  display: none;
}

.mapbox-gl-draw_home {
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: auto;
  background-image: url("../../assets/img/map-control-icons/home-solid.svg");
  background-size: 20px 30px;
}

.mapbox-gl-draw_legend {
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: auto;
  background-image: url("../../assets/img/map-control-icons/list-solid.svg");
  background-size: 20px 30px;
}

.map-tools-container {
  z-index: 500;
  position: absolute;
  bottom: 12px;
  left: 12px;
  width: 250px;
  background-color: rgba(255, 255, 255, 0) !important;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
}

.draw-info-container {
  z-index: 500;
  position: absolute;
  top: 185px;
  left: 49px;
  max-width: 150px;
  /* height: 20px; */
  opacity: 0.85;
  color: #f2f2f2;
  background: #323232;
  padding: 10px;
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
}
</style>
